import { Component } from '@angular/core';
import { FieldWrapper, FormlyFieldConfig, FormlyFieldProps as CoreFormlyFieldProps } from '@ngx-formly/core';

export interface FormlyFieldSimpleProps extends CoreFormlyFieldProps {
    hideRequiredMarker?: boolean;
    hideLabel?: boolean;
    markAsRequired?: boolean;
    vertical?: boolean;
}

@Component({
    selector: 'formly-wrapper-simple-form-field',
    template: `
        <div class="field grid">
            <label [attr.for]="id" class="col-12" *ngIf="props.label && props.hideLabel !== true" [ngClass]="{'mb-2 md:col-5 md:mb-0': !props.vertical}">
                <span>{{ props.label }}</span>
                <span *ngIf="props.markAsRequired === true" aria-hidden="true" class="k-required">*</span>
            </label>
            <div class="col-12" [ngClass]="{'md:col-7': !props.vertical && props.hideLabel !== true}">
                <ng-template #fieldComponent></ng-template>
            </div>

            <div *ngIf="showError" class="col-12">
                <formly-validation-message [field]="field"></formly-validation-message>
            </div>
        </div>
    `,
    host: { class: 'f-wrapper' }
})
export class FormlyWrapperSimpleFormField extends FieldWrapper<FormlyFieldConfig<FormlyFieldSimpleProps>> { }
/*
 <div class="p-field">
      <label *ngIf="props.label && props.hideLabel !== true" [for]="id">
        {{ props.label }}
        <span *ngIf="props.required && props.hideRequiredMarker !== true" aria-hidden="true">*</span>
        <span *ngIf="props.markAsRequired === true" aria-hidden="true" class="k-required">*</span>
      </label>
      <ng-container #fieldComponent></ng-container>

      <small *ngIf="showError" class="p-error">
        <formly-validation-message class="ui-message-text" [field]="field"></formly-validation-message>
      </small>
    </div>
*/
